﻿var vm;

(function () {
    'use strict';
    var controllerId = 'appointmentReportByIdCtrl';
    angular
    .module('app.controllers')
    .controller(controllerId, appointmentReportByIdCtrl)

    appointmentReportByIdCtrl.$inject = ['common', 'datacontext', '$http', '$scope', '$stateParams'];

    function appointmentReportByIdCtrl(common, datacontext, $http, $scope, $stateParams) {
        vm = this;
        vm.cita = $stateParams.idap;
        vm.userTimeZone = $stateParams.userTimeZone;
        
        function init() {
            
            common.activateController([])
                .then(function (data) {                    
                    var divElement = angular.element(document.querySelector('#header'));
                    divElement.remove();
                    $("#reportViewer").telerik_ReportViewer({
                        scaleMode: "SPECIFIC",
                        scale: 0.75,
                        //TODO: Utilizar la última versi+on, pero entender porque cambio serviceUrl
                        //templateUrl: "ReportViewer/templates/telerikReportViewerTemplate-9.2.15.930.html",                        
                        serviceUrl: common.config.basePaths.Report_Path_Resources,
                        templateUrl: "ReportViewer/templates/telerikReportViewerTemplate-10.1.16.615.html",                        
                        //serviceUrl: pathReport,
                        reportSource: {
                            report: "TDP.ReportLibrary.ReporteCitas, TDP.ReportLibrary",
                            parameters: {
                                AppointmentNo: vm.cita,
                                languageId: 1,
                                userTimeZone: -1*(vm.userTimeZone)

                            }
                        }
                    });                    

            });
            
        }

        init();
    }

})();